import { ISlide } from "../../../models/interactions/PowerSlideHelper";

/**
 * A single-slide clipboard, scoped to the session.
 *
 * Deliberately not the system clipboard: a slide's text lives in the training's
 * own localization table, so a copied slide is only meaningful inside the
 * training it came from. Keeping it in memory makes "copy here, paste into
 * another deck" exact, and keeps slide copy from colliding with the interaction
 * clipboard that Ctrl+C already writes.
 */
let clipboardSlide: ISlide | undefined;

export function writePowerSlideClipboard(slide: ISlide): void {
  // Snapshot, so later edits to the source slide do not mutate the clipboard.
  clipboardSlide = {
    ...slide,
    fields: { ...slide.fields },
    assets: (slide.assets ?? []).map((asset) => ({ ...asset })),
  };
}

export function readPowerSlideClipboard(): ISlide | undefined {
  return clipboardSlide;
}

export function hasPowerSlideClipboard(): boolean {
  return clipboardSlide !== undefined;
}

/** Test seam. */
export function clearPowerSlideClipboard(): void {
  clipboardSlide = undefined;
}
